import React from 'react';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import updateLocale from 'dayjs/plugin/updateLocale';
import enlocale from 'dayjs/locale/en';

dayjs.extend(relativeTime);
dayjs.extend(updateLocale);

dayjs.updateLocale('en', {
  relativeTime: {
    future: 'now',
    past: '%s ago',
    s: 'a few seconds',
    m: '1m',
    mm: '%dm',
    h: '1h',
    hh: '%dh',
    d: '1d',
    dd: '%dd',
    M: 'a month',
    MM: '%d months',
    y: 'a year',
    yy: '%d years'
  }
});
const otherLocale = {
  ...enlocale,
  name: 'countdown'
};
dayjs().locale(otherLocale);
dayjs().locale(enlocale);
dayjs.updateLocale('countdown', {
  relativeTime: {
    future: '%s',
    past: '0 seconds',
    s: '%d seconds',
    m: '1 minute',
    mm: '%d minutes',
    h: '1h',
    hh: '%dh',
    d: '1d',
    dd: '%dd',
    M: 'a month',
    MM: '%d months',
    y: 'a year',
    yy: '%d years'
  }
});

type Props = {
  time: Date | null | string;
  updateDuration?: number;
};
export const Timestamp: React.FC<Props> = (props) => {
  const { time, updateDuration } = props;
  const [dt, setDt] = useState(
    dayjs(time)
      .locale(updateDuration ? 'countdown' : 'en')
      .fromNow()
  );
  useEffect(() => {
    let secTimer = setInterval(
      () => {
        setDt(
          dayjs(time)
            .locale(updateDuration ? 'countdown' : 'en')
            .fromNow()
        );
      },
      updateDuration ? updateDuration : 10000
    );

    return () => clearInterval(secTimer);
  }, []);
  return <>{dt}</>;
};
